'use client';

import { FiltersData } from '@/types/offerWall';
import { SetStateAction, useEffect, useState } from 'react';
import staticStyles from './RangeInput.module.scss';

interface Props {
  min: number;
  max: number;
  styles: {
    readonly [key: string]: string;
  };
  label: string;
  format: 'dollars' | 'percent';
  type: 'rate' | 'amount';
  filtersData: FiltersData;
  setFiltersData: React.Dispatch<SetStateAction<FiltersData>>;
}

const RangeInput = ({
  min,
  max,
  styles,
  label,
  format,
  type,
  filtersData,
  setFiltersData,
}: Props) => {
  const [value, setValue] = useState(min);

  const labelValuesFormat = (labelValue: string | number) => {
    switch (format) {
      case 'dollars':
        return <>${labelValue}</>;
      case 'percent':
        return <>{labelValue}%</>;
      default:
        return null;
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value, 10);
    setValue(newValue);
    const percentage = ((newValue - min) / (max - min)) * 100;
    e.target.style.setProperty('--value', `${percentage}%`);
  };

  useEffect(() => {
    if (type === 'amount') {
      if (value === min) {
        setFiltersData((prev) => ({ ...prev, amount: null }));
      } else {
        setFiltersData((prev) => ({ ...prev, amount: value }));
      }
    } else if (type === 'rate') {
      if (value === min) {
        setFiltersData((prev) => ({ ...prev, rate: null }));
      } else {
        setFiltersData((prev) => ({ ...prev, rate: value }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    if (type === 'amount') {
      if (!filtersData.amount) {
        setValue(min);
      }
    }
    if (type === 'rate') {
      if (!filtersData.rate) {
        setValue(min);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersData]);

  return (
    <div className={styles.block}>
      <div className={styles.label}>
        <span style={{ opacity: 0.6 }}>{label}</span>
        <span>{labelValuesFormat(value)}</span>
      </div>
      <div className={staticStyles.inputWrapper}>
        <input
          type="range"
          value={value}
          className={staticStyles.input}
          onChange={handleInputChange}
          min={min}
          max={max}
        />
        <div className={staticStyles.valuesWrapper}>
          <span className={staticStyles.minmaxValue}>
            {labelValuesFormat(min)}
          </span>
          <span className={staticStyles.minmaxValue}>
            {labelValuesFormat(max)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RangeInput;
